import { render, staticRenderFns } from "./inquiryDetail.vue?vue&type=template&id=d09be7e4&scoped=true&"
import script from "./inquiryDetail.vue?vue&type=script&lang=js&"
export * from "./inquiryDetail.vue?vue&type=script&lang=js&"
import style0 from "./inquiryDetail.vue?vue&type=style&index=0&id=d09be7e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09be7e4",
  null
  
)

export default component.exports